import React from "react";
import styled from "styled-components";
import king from "../../Assets/team/king.png";
import JIKITA from "../../Assets/team/jikita.png";
import DARKARKI from "../../Assets/team/darkarky.png";
import GINI from "../../Assets/team/gini.png";
import ARTKDEV from "../../Assets/team/Artkdev.png";
import background from "../../Assets/team/obj.svg";
import link from "../../Assets/team/link.png";
import inst from "../../Assets/team/inst.png";
import site from "../../Assets/team/Group 5.png";

const StyledSection = styled.div`
  padding: 100px 5vw;
  width: 100%;
  min-height: 1000px;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  background: no-repeat url(${background});
  background-color: #21641d;
  background-position: center;
  background-size: cover;
  .wrapper {
    display: flex;
    width: 100%;
    max-width: 1230px;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    margin-bottom: 50px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 900;
    font-size: 70px;
    line-height: 85px;
    letter-spacing: 0.08em;
    text-transform: uppercase;

    color: #ffffff;
  }
  .container {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-basis: 528px;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    .card {
      background: #2e8546;
      width: 528px;
      height: fit-content;

      box-sizing: border-box;
      border-radius: 29px;

      padding: 29px;

      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      gap: 1vw;
      img {
        width: 132px;
        height: 132px;
        border-radius: 20px;
      }
      .link {
        display: flex;
        gap: 0.5vw;
        text-decoration: none;
        align-items: center;
        img {
          width: 25px;
          height: 25px;
        }
      }
      .text {
        width: 326px;
        height: fit-content;
        h2 {
          font-family: Montserrat;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          line-height: 24px;
          text-transform: uppercase;

          color: #ffffff;
        }
        h3 {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 24px;

          color: #ffffff;
        }
        p {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 300;
          font-size: 20px;
          line-height: 24px;

          color: #ffffff;
        }
      }
    }
  }
  @media (max-width: 534px) {
    padding: 100px 5vw;
    .wrapper {
    }
    h1 {
      margin-bottom: 30px;
      font-size: 30px;
      line-height: 85px;
    }
    .container {
      .card {
        width: 340px;
        flex-wrap: wrap;
        padding: 20px;

        img {
          display: none;
        }
        .link {
          img {
            display: flex;
          }
        }
      }
    }
  }

  @media (max-width: 360px) {
    .wrapper {
      max-width: 300px;
    }
    h1 {
      font-size: 30px;
      line-height: 80px;
    }
    .container {
      .card {
        width: 300px;
      }
    }
  }
`;

export default function Team() {
  return (
    <StyledSection id="Section6">
      <div className="wrapper">
        <h1>Team</h1>
        <div className="container">
          <div className="card">
            <img src={JIKITA} alt="" />
            <div className="text">
              <a
                className="link"
                href="https://www.linkedin.com/in/joseph-krol-6b553b3b/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <h2>JK</h2>
                <img src={link} alt="" />
              </a>

              <h3>Ideologist and management participant.</h3>
              <p>Blockchain’s ex friend.</p>
            </div>
          </div>
          <div className="card">
            <img src={DARKARKI} alt="" />
            <div className="text">
              <a
                className="link"
                href="https://www.linkedin.com/in/artem-krol-a485411a8/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <h2>Darkarki</h2>
                <img src={link} alt="" />
              </a>

              <h3>Project technical management. NFT Collector.</h3>
              <p>Blockchain’s new friend.</p>
            </div>
          </div>
          <div className="card">
            <img src={GINI} alt="" />
            <div className="text">
              <a
                className="link"
                href="https://instagram.com/gini_tattoo?igshid=YmMyMTA2M2Y="
                target="_blank"
                rel="noreferrer noopener"
              >
                <h2>GiNi</h2>
                <img src={inst} alt="" />
              </a>
              <h3>Artist, tattoo master and nice fellow.</h3>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </StyledSection>
  );
}
